import React from "react";
import { Form, Typography } from "antd";
import { getFormItemLabel } from "../../util/helpers";
import PropTypes from "prop-types";
import { useIntl } from "react-intl";
import { getLocalPhoneNumber } from "../../util/helpers";

const { Text } = Typography;

const InputItem = (props) => {
  const { name, category, phone, border } = props;
  const intl = useIntl();
  const label = getFormItemLabel(intl, category, name, null);
  const ContentComponent = ({ value }) => {
    return value ? (
      <Text ellipsis style={{ whiteSpace: "normal" }}>
        {phone && value ? getLocalPhoneNumber(value) : value}
      </Text>
    ) : border ? (
      <div className="underline" />
    ) : null;
  };
  return (
    <div>
      <Form.Item label={label} name={name}>
        <ContentComponent />
      </Form.Item>
    </div>
  );
};

InputItem.propTypes = {
  name: PropTypes.string,
  category: PropTypes.string,
};

export default InputItem;
